import store from '../../store/store';

export const validation = ({ email, password }) => {
  const { config } = store.getState((state) => state);
  const { WITH_LOGIN_VALIDATION, WITH_HARD_VALIDATION } = config;

  let temp = {};
  if (password) {
    const trimmedPassword = password.trim();
 if (trimmedPassword === '') {
    temp.password = 'password is required';
  }

  if (WITH_HARD_VALIDATION) {
    if (!/(?=.*[A-Z])/.test(trimmedPassword)) {
      temp.password = 'password needs at least one Uppercase character';
    }
    if (!/(?=.*[0-9])/.test(trimmedPassword)) {
      temp.password = 'password needs at least one number';
    }

    if (trimmedPassword.length < 6) {
      temp.password = 'password needs to be at least six characters';
    }
  }
 }

if (email) {
 if (!/\S+@\S+\.\S+/.test(email)) {
    temp.email = 'Please enter a valid email';
  }
 }

  return WITH_LOGIN_VALIDATION ? {} : temp;
};
